/**
 * Admin 초대장. 라우트 admin.php invitations 와 동기화.
 */
import { Logger } from "../../utils/Logger";
import { Modal } from "../../utils/Modal";

function noop(controller: string, action: string): void {
    Logger.debug(`${controller}.${action} (no-op)`);
}

function copyToClipboard(text: string): Promise<void> {
    if (navigator.clipboard?.writeText) {
        return navigator.clipboard.writeText(text);
    }
    const el = document.createElement("input");
    el.value = text;
    document.body.appendChild(el);
    el.select();
    document.execCommand("copy");
    document.body.removeChild(el);
    return Promise.resolve();
}

export const InvitationController = {
    index(): void {
        document.querySelectorAll<HTMLElement>("[data-copy-invite-url]").forEach((btn) => {
            btn.addEventListener("click", () => {
                const url = btn.getAttribute("data-copy-invite-url");
                if (!url) return;
                copyToClipboard(url)
                    .then(() => void Modal.alert("URL이 복사되었습니다."))
                    .catch(() => {
                        const el = document.createElement("input");
                        el.value = url;
                        document.body.appendChild(el);
                        el.select();
                        document.execCommand("copy");
                        document.body.removeChild(el);
                        void Modal.alert("URL이 복사되었습니다.");
                    });
            });
        });
    },
    create(): void {
        noop("InvitationController", "create");
    },
    store(): void {
        noop("InvitationController", "store");
    },
    destroy(): void {
        noop("InvitationController", "destroy");
    },
};
